import signedFetch from './util/signedFetch.js';

/**
 * This takes a file upload as input, parses the file to validate it, then forwards it on to S3 and notifies EAC of its presence in S3
 *  - orgId: Integer
 *  - activation: List[String]
 */
export default (orgId, body) =>
  signedFetch('bulkLicenceUpload', `${__API_BASE__}/org/${encodeURIComponent(orgId)}/licence/upload`, 'POST', body);
